// Generated by ReScript, PLEASE EDIT WITH CARE


function importCss(param) {
  return (require(`CreateCustomerAssets/styles/_all.scss`));
}

export {
  importCss ,
  
}
/* No side effect */
